<div class="landing-container">

  <!-- NAVBAR -->
  <NavbarSection />

  <!-- HERO SECTION -->
  <HeroSection />

  <!-- FOOTER -->
  <FooterSection />

</div>